var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('r-form',_vm._b({ref:"refCFDailyLedger",attrs:{"reset-text":"reiniciar","submit-text":"generar","title":"Generar libro diario"},on:{"submit":_vm.submitDownloadDailyLedgerExcel}},'r-form',_vm.formProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }